import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core'
import { MatSidenav } from '@angular/material/sidenav'
import { ActivatedRoute } from '@angular/router'
import { UserContextService } from '@core/service/user-context.service'
import { getRole } from '@shared/utils/degts-utils'
import { HeaderComponent } from '../header/header.component'
import { SidenavService } from '../services/sidenav.service'
import { SideMenuItemConfig, SIDE_MENU_ITEMS, SideMenuSubItem } from './sidenav-items'

const SIDENAV_GAP_OFFSET = 42
@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavComponent implements AfterViewInit, OnInit, OnDestroy {
  @Input()
  titulo: string

  hasBackdrop: boolean

  containerDefault = true

  mode: string

  items: SideMenuItemConfig[]

  gap = SIDENAV_GAP_OFFSET

  elementFooter: HTMLElement

  @ViewChild('sidenav')
  public sidenav: MatSidenav

  @ViewChild('appHeader')
  public headerComponent: HeaderComponent

  constructor(
    private sidenavService: SidenavService,
    private userContext: UserContextService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    if (this.activatedRoute?.firstChild?.snapshot?.data?.containerDefault !== undefined) {
      this.containerDefault = this.activatedRoute.firstChild.snapshot.data.containerDefault
    }
    this.items = []
    const filteredItems = SIDE_MENU_ITEMS.filter((item) => {
      if (this.userContext.vinculoAtual) {
        return (
          item.roles.map((role) => role.descricao).includes(this.userContext.vinculoAtual.role.name) &&
          this.isAcessivelParaResidenteInativo(item)
        )
      }

      return this.userContext.hasAnyRole(item.roles) && this.isAcessivelParaResidenteInativo(item)
    }).map((item) => ({ ...item, to: this.resolveRouteParameter(item.to) }))
    filteredItems.forEach((item) => {
      const subItemFiltered = item.children?.filter((subItem) => {
        if (this.userContext.vinculoAtual) {
          return (
            subItem.roles.map((role) => role.descricao).includes(this.userContext.vinculoAtual.role.name) &&
            this.isAcessivelParaResidenteInativo(subItem)
          )
        }
        return this.userContext.hasAnyRole(subItem.roles) && this.isAcessivelParaResidenteInativo(subItem)
      })
      item.children = subItemFiltered
      this.items.push(item)
    })

    this.elementFooter = document.getElementById('outer-footer')
    this.changeFooter('none')
  }

  private isAcessivelParaResidenteInativo(item: SideMenuItemConfig | SideMenuSubItem): boolean {
    if (!this.isResidente || this.userContext.residenteUser.ativo) {
      return true
    }

    if (item.isRotaResidenteInativo && !this.userContext.residenteUser.ativo) {
      return true
    }

    return false
  }

  ngOnDestroy(): void {
    this.changeFooter('block')
  }

  private changeFooter(display: string) {
    if (this.elementFooter) {
      this.elementFooter.style.display = display
    }
  }

  ngAfterViewInit(): void {
    this.sidenavService.setSidenav(this.sidenav)
    this.checkWindowSize()
  }

  @HostListener('window:resize', [])
  onResize(): void {
    this.checkWindowSize()
  }

  onHeaderScrollTopChanged(value: number) {
    this.gap = value >= SIDENAV_GAP_OFFSET ? 0 : SIDENAV_GAP_OFFSET - value
  }

  onActivate(event) {
    window.scroll(0, 0)
  }

  private checkWindowSize(): void {
    if (window.innerWidth < 1920) {
      this.hasBackdrop = true
      this.sidenav.disableClose = false
      this.mode = 'over'
      this.sidenav.close()
    } else {
      this.sidenav.disableClose = true
      this.hasBackdrop = false
      this.mode = 'side'
      this.sidenav.open()
    }
  }

  get isDegts() {
    return this.userContext.hasRole(getRole('ROLE_DEGTS'))
  }

  get isDev() {
    return this.userContext.hasRole(getRole('ROLE_DEV'))
  }

  get isFinanceiro() {
    return this.userContext.hasRole(getRole('ROLE_FINANCEIRO'))
  }

  get isTransferencia() {
    return this.userContext.hasRole(getRole('ROLE_TRANSFERENCIA'))
  }

  get isResidente() {
    return this.userContext.isResidente()
  }

  get isAdministrador() {
    return this.userContext.isAdministrador()
  }

  get showNavList() {
    return (
      this.isDegts ||
      this.isFinanceiro ||
      this.isTransferencia ||
      this.isResidente ||
      this.isDev ||
      this.isAdministrador ||
      this.userContext.userInfo?.vinculoAtual != null
    )
  }

  private getParameterProgramaId() {
    const programaId =
      this.userContext?.vinculoAtual?.programa?.hashPrograma || this.userContext?.vinculoAtual?.programa?.programaId
    return `${programaId}`
  }

  private resolveRouteParameter(to: string) {
    const regexProgramaId = /{programaId}/g
    return regexProgramaId.test(to) ? to.replace(regexProgramaId, this.getParameterProgramaId()) : to
  }
}
